import type { ReactNode } from "react";
import { cn } from "@/utils/cn";

type ChipVariant = "default" | "accent" | "signal";

type ChipProps = {
  variant?: ChipVariant;
  className?: string;
  children: ReactNode;
};

export function Chip({ variant = "default", className, children }: ChipProps) {
  return (
    <span
      className={cn(
        "chip",
        variant === "accent" && "accent",
        variant === "signal" && "signal",
        className
      )}
    >
      {children}
    </span>
  );
}
